import getStore from '../store/store';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { formatShortWeekDayMonthDayYear } from 'owa-datetime';
import { DayGridScenario, DayGridView } from 'owa-day-grid';
import loc from 'owa-localize';
import { format } from 'owa-string-utils';
import React from 'react';
import {
    navigateToNextInstanceAriaLabel,
    navigateToPreviousInstanceAriaLabel,
    recurringInstanceCounter,
} from './ConflictsView.locstring.json';
import {
    navigateToPreviousInstance,
    navigateToNextInstance,
} from '../actions/timePanelConflictsViewActions';

const styles = require('./ConflictsView.scss');

export default observer(function ConflictsView() {
    const { futureInstances, selectedInstanceIndex } = getStore();

    if (!futureInstances) {
        return null;
    }

    const selectedInstance = futureInstances[selectedInstanceIndex];

    return (
        <>
            <div className={styles.header}>
                {formatShortWeekDayMonthDayYear(selectedInstance.Start)}
            </div>
            {futureInstances.length > 1 && (
                <div className={styles.instanceSummary}>
                    <IconButton
                        iconProps={{ iconName: ControlIcons.DoubleChevronLeft }}
                        onClick={navigateToPreviousInstance}
                        ariaLabel={loc(navigateToPreviousInstanceAriaLabel)}
                    />
                    <IconButton
                        iconProps={{ iconName: ControlIcons.DoubleChevronRight }}
                        onClick={navigateToNextInstance}
                        ariaLabel={loc(navigateToNextInstanceAriaLabel)}
                    />
                    <span>
                        {format(
                            loc(recurringInstanceCounter),
                            selectedInstanceIndex + 1,
                            futureInstances.length
                        )}
                    </span>
                </div>
            )}
            <div className={styles.conflictsContainer}>
                <DayGridView
                    scenario={DayGridScenario.TimePanelConflictsView}
                    shadeWorkingHours={false}
                />
            </div>
        </>
    );
});
